export enum VisitType {
  RationingTool = 'Daily Allowance',
  WeightManagement = 'Weight management',
  SmartReco = 'Smart Recommendation',
  Multifunction = 'Multifunction',
  RenalDetect = 'Renal Detect',
}
